import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Busca/Busca.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Grid/Grid.module.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Title/Title.module.scss")